/**
  * @function evalute - evaluate constantBehavior
  */

const evaluate = async source => {
  const value = source.value;
  return value;
};
module.exports = {
  evaluate
};